// extracted by mini-css-extract-plugin
export var badge = "_hn-2";
export var detailsPanel = "_hn-0";
export var resultRow = "_hn-1";